import { Component } from '@angular/core';

@Component({
  selector: 'completed-projects',
  templateUrl: './completed-projects.component.html',
  styleUrls: ['./completed-projects.component.scss']
})
export class CompletedProjectsComponent {
  public getRouterLinkNew() {
    return '/client-project/nieuw/0';
  }
}
